import React, { Fragment } from 'react'

import PropTypes from 'prop-types'

import './team3.css'

const Team3 = (props) => {
  return (
    <div
      id={props.team3Id}
      className={`team3-team12 thq-section-padding ${props.rootClassName} `}
    >
      <div className="team3-max-width thq-section-max-width">
        <div className="team3-section-title">
          <div className="team3-content1">
            <h2 className="thq-heading-2">
              {props.heading1 ?? (
                <Fragment>
                  <span className="team3-text61">Meet Our Visionaries</span>
                </Fragment>
              )}
            </h2>
            <span className="team3-text11">
              {props.text5 ?? (
                <Fragment>
                  <span className="team3-text77">
                    Driving excellence in real estate with unmatched expertise
                    and a passion for delivering value.
                  </span>
                </Fragment>
              )}
            </span>
          </div>
        </div>
        <div className="team3-content2">
          <div className="team3-content3">
            
            <div className="team3-row2">
            <div className="team3-card2">
                <img
                  alt="Image of John Doe"
                  src="/whatsapp%20image%202025-01-02%20at%2020.55.28-800w.jpeg"
                  className="team3-member-image2 thq-img-ratio-1-1"
                />
                <div className="team3-content5">
                  <div className="team3-title2">
                    <span className="team3-text17 thq-body-small">
                      {props.member12 ?? (
                        <Fragment>
                          <span className="team3-text32">
                            <span>Shenoth Raghavan</span>
                            <br></br>
                          </span>
                        </Fragment>
                      )}
                    </span>
                    <span className="team3-text18 thq-body-small">
                      {props.member1Job2 ?? (
                        <Fragment>
                          <span className="team3-text81">Director</span>
                        </Fragment>
                      )}
                    </span>
                  </div>
                  <div className="team3-container3">
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      className="team3-icon18"
                    >
                      <path
                        d="M20 18h-2V9.25L12 13L6 9.25V18H4V6h1.2l6.8 4.25L18.8 6H20m0-2H4c-1.11 0-2 .89-2 2v12a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2"
                        fill="currentColor"
                      ></path>
                    </svg>
                    <span className="team3-text19">
                      {props.text3 ?? (
                        <Fragment>
                          <span className="team3-text54">
                            <span>shenoth@omshashvath.com</span>
                            <br></br>
                          </span>
                        </Fragment>
                      )}
                    </span>
                  </div>
                  <div className="team3-container4">
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 32 32"
                      className="team3-icon20"
                    >
                      <path
                        d="m20.33 21.48l2.24-2.24a2.19 2.19 0 0 1 2.34-.48l2.73 1.09a2.18 2.18 0 0 1 1.36 2v5A2.17 2.17 0 0 1 26.72 29C7.59 27.81 3.73 11.61 3 5.41A2.17 2.17 0 0 1 5.17 3H10a2.16 2.16 0 0 1 2 1.36l1.09 2.73a2.16 2.16 0 0 1-.47 2.34l-2.24 2.24s1.29 8.73 9.95 9.81"
                        fill="currentColor"
                      ></path>
                    </svg>
                    <span className="team3-text20">
                      {props.text21 ?? (
                        <Fragment>
                          <span className="team3-text74">
                            <span>+91 9841335248</span>
                            <br></br>
                          </span>
                        </Fragment>
                      )}
                    </span>
                  </div>
                  <span className="team3-text21 thq-body-small">
                    {props.member1Content2 ?? (
                      <Fragment>
                        <span className="team3-text67">
                        Shenoth Raghavan possesses more than 16 years of vast experience
              in the buying, selling, and leasing of both commercial and
              residential properties, advisor for property management and
              customer service management. Excellent documentation and extensive
              experience in obtaining housing loans, project funding, and
              mortgage loans.
                        </span>
                      </Fragment>
                    )}
                  </span>
                </div>
                <div className="team3-social-icons2">
                  <svg
                    viewBox="0 0 877.7142857142857 1024"
                    className="thq-icon-small"
                  >
                    <path d="M135.429 808h132v-396.571h-132v396.571zM276 289.143c-0.571-38.857-28.571-68.571-73.714-68.571s-74.857 29.714-74.857 68.571c0 37.714 28.571 68.571 73.143 68.571h0.571c46.286 0 74.857-30.857 74.857-68.571zM610.286 808h132v-227.429c0-121.714-65.143-178.286-152-178.286-70.857 0-102.286 39.429-119.429 66.857h1.143v-57.714h-132s1.714 37.143 0 396.571v0h132v-221.714c0-11.429 0.571-23.429 4-32 9.714-23.429 31.429-48 68-48 47.429 0 66.286 36 66.286 89.714v212zM877.714 237.714v548.571c0 90.857-73.714 164.571-164.571 164.571h-548.571c-90.857 0-164.571-73.714-164.571-164.571v-548.571c0-90.857 73.714-164.571 164.571-164.571h548.571c90.857 0 164.571 73.714 164.571 164.571z"></path>
                  </svg>
                  <svg
                    viewBox="0 0 950.8571428571428 1024"
                    className="thq-icon-small"
                  >
                    <path d="M925.714 233.143c-25.143 36.571-56.571 69.143-92.571 95.429 0.571 8 0.571 16 0.571 24 0 244-185.714 525.143-525.143 525.143-104.571 0-201.714-30.286-283.429-82.857 14.857 1.714 29.143 2.286 44.571 2.286 86.286 0 165.714-29.143 229.143-78.857-81.143-1.714-149.143-54.857-172.571-128 11.429 1.714 22.857 2.857 34.857 2.857 16.571 0 33.143-2.286 48.571-6.286-84.571-17.143-148-91.429-148-181.143v-2.286c24.571 13.714 53.143 22.286 83.429 23.429-49.714-33.143-82.286-89.714-82.286-153.714 0-34.286 9.143-65.714 25.143-93.143 90.857 112 227.429 185.143 380.571 193.143-2.857-13.714-4.571-28-4.571-42.286 0-101.714 82.286-184.571 184.571-184.571 53.143 0 101.143 22.286 134.857 58.286 41.714-8 81.714-23.429 117.143-44.571-13.714 42.857-42.857 78.857-81.143 101.714 37.143-4 73.143-14.286 106.286-28.571z"></path>
                  </svg>
                </div>
              </div>
              <div className="team3-card3">
                <img
                  alt={props.member1Alt21}
                  src="/whatsapp%20image%202025-01-02%20at%2020.56.53-800w.jpeg"
                  className="team3-member-image3 thq-img-ratio-1-1"
                />
                <div className="team3-content6">
                  <div className="team3-title3">
                    <span className="team3-text22 thq-body-small">
                      {props.member121 ?? (
                        <Fragment>
                          <span className="team3-text58">
                            <span>Rajkumar S</span>
                            <br></br>
                          </span>
                        </Fragment>
                      )}
                    </span>
                    <span className="team3-text23 thq-body-small">
                      {props.member1Job21 ?? (
                        <Fragment>
                          <span className="team3-text62">Director</span>
                        </Fragment>
                      )}
                    </span>
                  </div>
                  <div className="team3-container5">
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      className="team3-icon26"
                    >
                      <path
                        d="M20 18h-2V9.25L12 13L6 9.25V18H4V6h1.2l6.8 4.25L18.8 6H20m0-2H4c-1.11 0-2 .89-2 2v12a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2"
                        fill="currentColor"
                      ></path>
                    </svg>
                    <span className="team3-text24">
                      {props.text31 ?? (
                        <Fragment>
                          <span className="team3-text64">
                            <span>rajkumars@omshashvath.com</span>
                            <br></br>
                          </span>
                        </Fragment>
                      )}
                    </span>
                  </div>
                  <div className="team3-container6">
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 32 32"
                      className="team3-icon28"
                    >
                      <path
                        d="m20.33 21.48l2.24-2.24a2.19 2.19 0 0 1 2.34-.48l2.73 1.09a2.18 2.18 0 0 1 1.36 2v5A2.17 2.17 0 0 1 26.72 29C7.59 27.81 3.73 11.61 3 5.41A2.17 2.17 0 0 1 5.17 3H10a2.16 2.16 0 0 1 2 1.36l1.09 2.73a2.16 2.16 0 0 1-.47 2.34l-2.24 2.24s1.29 8.73 9.95 9.81"
                        fill="currentColor"
                      ></path>
                    </svg>
                    <span className="team3-text25">
                      {props.text211 ?? (
                        <Fragment>
                          <span className="team3-text68">
                            <span>+91 8939960345</span>
                            <br></br>
                          </span>
                        </Fragment>
                      )}
                    </span>
                  </div>
                  <span className="team3-text26 thq-body-small">
                    {props.member1Content21 ?? (
                      <Fragment>
                        <span className="team3-text71">
                          <span>
                            With 15 years of experience, Rajkumar specializes in
                            arranging out-rate and joint development properties
                            for builders. He is also skilled in handling various
                            residential and commercial properties, along with
                            facilitating loan arrangements for clients.
                          </span>
                          <br></br>
                        </span>
                      </Fragment>
                    )}
                  </span>
                </div>
                <div className="team3-social-icons3">
                  <svg
                    viewBox="0 0 877.7142857142857 1024"
                    className="thq-icon-small"
                  >
                    <path d="M135.429 808h132v-396.571h-132v396.571zM276 289.143c-0.571-38.857-28.571-68.571-73.714-68.571s-74.857 29.714-74.857 68.571c0 37.714 28.571 68.571 73.143 68.571h0.571c46.286 0 74.857-30.857 74.857-68.571zM610.286 808h132v-227.429c0-121.714-65.143-178.286-152-178.286-70.857 0-102.286 39.429-119.429 66.857h1.143v-57.714h-132s1.714 37.143 0 396.571v0h132v-221.714c0-11.429 0.571-23.429 4-32 9.714-23.429 31.429-48 68-48 47.429 0 66.286 36 66.286 89.714v212zM877.714 237.714v548.571c0 90.857-73.714 164.571-164.571 164.571h-548.571c-90.857 0-164.571-73.714-164.571-164.571v-548.571c0-90.857 73.714-164.571 164.571-164.571h548.571c90.857 0 164.571 73.714 164.571 164.571z"></path>
                  </svg>
                  <svg
                    viewBox="0 0 950.8571428571428 1024"
                    className="thq-icon-small"
                  >
                    <path d="M925.714 233.143c-25.143 36.571-56.571 69.143-92.571 95.429 0.571 8 0.571 16 0.571 24 0 244-185.714 525.143-525.143 525.143-104.571 0-201.714-30.286-283.429-82.857 14.857 1.714 29.143 2.286 44.571 2.286 86.286 0 165.714-29.143 229.143-78.857-81.143-1.714-149.143-54.857-172.571-128 11.429 1.714 22.857 2.857 34.857 2.857 16.571 0 33.143-2.286 48.571-6.286-84.571-17.143-148-91.429-148-181.143v-2.286c24.571 13.714 53.143 22.286 83.429 23.429-49.714-33.143-82.286-89.714-82.286-153.714 0-34.286 9.143-65.714 25.143-93.143 90.857 112 227.429 185.143 380.571 193.143-2.857-13.714-4.571-28-4.571-42.286 0-101.714 82.286-184.571 184.571-184.571 53.143 0 101.143 22.286 134.857 58.286 41.714-8 81.714-23.429 117.143-44.571-13.714 42.857-42.857 78.857-81.143 101.714 37.143-4 73.143-14.286 106.286-28.571z"></path>
                  </svg>
                </div>
              </div>
              <div className="team3-card4">
                <img
                  alt={props.member1Alt3}
                  src="/whatsapp%20image%202025-01-02%20at%2021.03.36-removebg-preview-800w.jpg"
                  className="team3-member-image4 thq-img-ratio-1-1"
                />
                <div className="team3-content7">
                  <div className="team3-title4">
                    <span className="team3-text27 thq-body-small">
                      {props.member13 ?? (
                        <Fragment>
                          <span className="team3-text78">
                            <span>Satish Kumar Repaka</span>
                            <br></br>
                          </span>
                        </Fragment>
                      )}
                    </span>
                    <span className="team3-text28 thq-body-small">
                      {props.member1Job3 ?? (
                        <Fragment>
                          <span className="team3-text42">
                            <span>Vice president</span>
                            <br></br>
                          </span>
                        </Fragment>
                      )}
                    </span>
                  </div>
                  <div className="team3-container7">
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      className="team3-icon34"
                    >
                      <path
                        d="M20 18h-2V9.25L12 13L6 9.25V18H4V6h1.2l6.8 4.25L18.8 6H20m0-2H4c-1.11 0-2 .89-2 2v12a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2"
                        fill="currentColor"
                      ></path>
                    </svg>
                    <span className="team3-text29">
                      {props.text4 ?? (
                        <Fragment>
                          <span className="team3-text51">
                            <span>repaka@omshashvath.com</span>
                            <br></br>
                          </span>
                        </Fragment>
                      )}
                    </span>
                  </div>
                  <div className="team3-container8">
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 32 32"
                      className="team3-icon36"
                    >
                      <path
                        d="m20.33 21.48l2.24-2.24a2.19 2.19 0 0 1 2.34-.48l2.73 1.09a2.18 2.18 0 0 1 1.36 2v5A2.17 2.17 0 0 1 26.72 29C7.59 27.81 3.73 11.61 3 5.41A2.17 2.17 0 0 1 5.17 3H10a2.16 2.16 0 0 1 2 1.36l1.09 2.73a2.16 2.16 0 0 1-.47 2.34l-2.24 2.24s1.29 8.73 9.95 9.81"
                        fill="currentColor"
                      ></path>
                    </svg>
                    <span className="team3-text30">
                      {props.text22 ?? (
                        <Fragment>
                          <span className="team3-text48">
                            <span>+91 9445609145</span>
                            <br></br>
                          </span>
                        </Fragment>
                      )}
                    </span>
                  </div>
                  <span className="team3-text31 thq-body-small">
                    {props.member1Content3 ?? (
                      <Fragment>
                        <span className="team3-text41">
                        Satish Kumar Repaka is a seasoned real estate broker with 13 years of proven expertise in generating high-quality leads and closing deals, demonstrating a strong ability to self-source and execute transactions. He cultivates strong relationships within his extensive network and collaborates seamlessly with a team of professionals to achieve successful deal closures.
                        </span>
                      </Fragment>
                    )}
                  </span>
                </div>
                <div className="team3-social-icons4">
                  <svg
                    viewBox="0 0 877.7142857142857 1024"
                    className="thq-icon-small"
                  >
                    <path d="M135.429 808h132v-396.571h-132v396.571zM276 289.143c-0.571-38.857-28.571-68.571-73.714-68.571s-74.857 29.714-74.857 68.571c0 37.714 28.571 68.571 73.143 68.571h0.571c46.286 0 74.857-30.857 74.857-68.571zM610.286 808h132v-227.429c0-121.714-65.143-178.286-152-178.286-70.857 0-102.286 39.429-119.429 66.857h1.143v-57.714h-132s1.714 37.143 0 396.571v0h132v-221.714c0-11.429 0.571-23.429 4-32 9.714-23.429 31.429-48 68-48 47.429 0 66.286 36 66.286 89.714v212zM877.714 237.714v548.571c0 90.857-73.714 164.571-164.571 164.571h-548.571c-90.857 0-164.571-73.714-164.571-164.571v-548.571c0-90.857 73.714-164.571 164.571-164.571h548.571c90.857 0 164.571 73.714 164.571 164.571z"></path>
                  </svg>
                  <svg
                    viewBox="0 0 950.8571428571428 1024"
                    className="thq-icon-small"
                  >
                    <path d="M925.714 233.143c-25.143 36.571-56.571 69.143-92.571 95.429 0.571 8 0.571 16 0.571 24 0 244-185.714 525.143-525.143 525.143-104.571 0-201.714-30.286-283.429-82.857 14.857 1.714 29.143 2.286 44.571 2.286 86.286 0 165.714-29.143 229.143-78.857-81.143-1.714-149.143-54.857-172.571-128 11.429 1.714 22.857 2.857 34.857 2.857 16.571 0 33.143-2.286 48.571-6.286-84.571-17.143-148-91.429-148-181.143v-2.286c24.571 13.714 53.143 22.286 83.429 23.429-49.714-33.143-82.286-89.714-82.286-153.714 0-34.286 9.143-65.714 25.143-93.143 90.857 112 227.429 185.143 380.571 193.143-2.857-13.714-4.571-28-4.571-42.286 0-101.714 82.286-184.571 184.571-184.571 53.143 0 101.143 22.286 134.857 58.286 41.714-8 81.714-23.429 117.143-44.571-13.714 42.857-42.857 78.857-81.143 101.714 37.143-4 73.143-14.286 106.286-28.571z"></path>
                  </svg>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

Team3.defaultProps = {
  member12: undefined,
  text: undefined,
  member1: undefined,
  member1Content3: undefined,
  member1Job3: undefined,
  text2: undefined,
  text22: undefined,
  text4: undefined,
  text3: undefined,
  member1Content: undefined,
  member121: undefined,
  heading1: undefined,
  member1Job21: undefined,
  member1Alt21: 'Image of John Doe',
  member1Job: undefined,
  text31: undefined,
  member1Content2: undefined,
  text211: undefined,
  member1Content21: undefined,
  text21: undefined,
  text5: undefined,
  member13: undefined,
  rootClassName: '',
  member1Alt3: 'Image of John Doe',
  member1Job2: undefined,
  team3Id: '',
}

Team3.propTypes = {
  member12: PropTypes.element,
  text: PropTypes.element,
  member1: PropTypes.element,
  member1Content3: PropTypes.element,
  member1Job3: PropTypes.element,
  text2: PropTypes.element,
  text22: PropTypes.element,
  text4: PropTypes.element,
  text3: PropTypes.element,
  member1Content: PropTypes.element,
  member121: PropTypes.element,
  heading1: PropTypes.element,
  member1Job21: PropTypes.element,
  member1Alt21: PropTypes.string,
  member1Job: PropTypes.element,
  text31: PropTypes.element,
  member1Content2: PropTypes.element,
  text211: PropTypes.element,
  member1Content21: PropTypes.element,
  text21: PropTypes.element,
  text5: PropTypes.element,
  member13: PropTypes.element,
  rootClassName: PropTypes.string,
  member1Alt3: PropTypes.string,
  member1Job2: PropTypes.element,
  team3Id: PropTypes.string,
}

export default Team3
